/* eslint-disable */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open: false,
    handleConfirm: null,
    message: "Click submit to proceed",
    loading: false,
    modalType: 'CONFIRMATION',   // NULL_SUBSCRIPTION, UPGRADE_SUBSCRIPTION, PURCHASED_PRODUCT etc
    closable: true,
    dialogStyle: {}
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const confirmationModal = createSlice({
    name: 'confirmationModal',
    initialState,
    reducers: {
        openConfirmationModal(state, action) {
            const { open, handleConfirm, message, modalType, closable, dialogStyle } = action.payload;

            state.open = open || initialState.open;
            state.handleConfirm = handleConfirm || initialState.handleConfirm;
            state.message = message || initialState.message;
            state.modalType = modalType || initialState.modalType;
            state.closable = closable;
            state.dialogStyle = dialogStyle || initialState.dialogStyle;
        },
        showLoading(state) {
            state.loading = !state.loading;
        },
        closeConfirmationModal(state) {
            state.open = false;
        }
    }
});

export default confirmationModal.reducer;

export const { openConfirmationModal, closeConfirmationModal, showLoading } = confirmationModal.actions;
